<script setup lang="ts">
/**
 * ToolbarGroup – beschrifteter Aktionsblock der {@link ScoreEditToolbar}.
 *
 * Kapselt eine thematisch zusammengehörige Button-Reihe als optisch abgesetzten Block mit kleiner
 * Text-Überschrift darüber (ersetzt die früheren dünnen `SEP`-Trennstriche). Das Label macht die
 * Gruppe verständlich, ohne dass Nutzer die einzelnen Icons deuten müssen. Rein präsentational – die
 * durchgereichten `<button>`s bleiben im Scope der ScoreEditToolbar und behalten dort ihr Styling.
 */
const {label = ''} = defineProps<{
  label?: string;
}>()

defineSlots<{
  default?: () => unknown;
}>()
</script>

<template>
  <!-- Das Label erscheint erst ab einer Vorschau-Breite von 48rem (`@container/preview` an der Wurzel
       von `MusicXmlPreview`); darunter kostete es eine Zeile je Toolbar-Reihe. `role="group"` +
       `aria-label` halten die Gruppierung für Screenreader auch ohne sichtbares Label. -->
  <div role="group" :aria-label="label || undefined" class="flex flex-col items-center gap-1 rounded-lg border border-gray-200 bg-gray-50/60 px-1 py-0.5 @3xl/preview:px-2 @3xl/preview:py-1">
    <span class="hidden text-[0.625rem] font-semibold uppercase tracking-wider leading-none text-gray-400 @3xl/preview:block">
      {{ label }}
    </span>
    <div class="flex items-center gap-1">
      <slot/>
    </div>
  </div>
</template>
